import type { MidiSpec } from '@tunasong/schemas'
import { useState } from 'react'
import { MidiCCEditor } from './midi-cc-editor.js'
import { MidiChannel } from './midi-channel.js'
import { MidiPCEditor } from './midi-pc-editor.js'
import {Divider, Tab, Tabs} from '@tunasong/ui-lib'
import styles from './midi-editor.module.css'

export interface MidiGridProps {
  /** use the specified MIDI channel. If not specified, use Omni (all channels) */
  channel?: number
  spec: MidiSpec
  onChange(spec: MidiSpec): void
  onChannelChange?(channel: number): void
}

export function MidiEditor({ spec, onChange, channel, onChannelChange }: MidiGridProps) {
  const [tab, setTab] = useState(0)
  const handleTab = (_ev: React.SyntheticEvent | null, value: string | number) => setTab(value as number)

  return (
    <div className={styles.container}>
      <MidiChannel defaultValue={channel} onChange={onChannelChange} />
      <Divider className={styles.divider} />

      <Tabs value={tab} onChange={handleTab}>
        <Tab value={0} label="Program Change (PC)" />
        <Tab value={1} label="Continuous Control (CC)" />
      </Tabs>
      <div className={styles.content}>
        {tab === 0 && <MidiPCEditor spec={spec} onChange={onChange} />}
        {tab === 1 && <MidiCCEditor spec={spec} onChange={onChange} />}
      </div>
    </div>
  )
}
